var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "box" },
        [
          _c("Header", { ref: "header" }),
          _c("GameBanner", {
            attrs: {
              src: _vm.gameData.topBgImage,
              variant: _vm.gameData.extraFields.bannerType,
              drawProductId: _vm.gameData.extraFields.bannerDrawProductId,
            },
          }),
          _c("div", { staticClass: "item_Options" }, [
            _c(
              "div",
              { staticClass: "content" },
              [
                _c("UserInfo", { ref: "userInfo" }),
                _c("div", { staticClass: "position" }, [
                  _c("div", { staticClass: "position-item" }, [
                    _c("div", { staticClass: "points-balance-container" }, [
                      _c("img", {
                        staticClass: "points-icon",
                        attrs: { src: "/static/image/points_new.png" },
                      }),
                      _c("p", { staticClass: "points-text" }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("pointsBalanceText")) +
                            ":\n\t\t\t\t\t\t\t\t"
                        ),
                        _c("span", { staticClass: "points-amount" }, [
                          _vm._v(_vm._s(_vm.balance)),
                        ]),
                      ]),
                      _c(
                        "button",
                        {
                          staticClass: "balance-refresh-btn",
                          class: {
                            "balance-refresh-btn--spinning": _vm.isRefreshing,
                          },
                          attrs: {
                            disabled: _vm.isRefreshing || !_vm.hasLogin,
                          },
                          on: { click: _vm.refreshBalance },
                        },
                        [_vm._v("↻")]
                      ),
                    ]),
                  ]),
                  _c(
                    "ul",
                    { staticClass: "points_box" },
                    _vm._l(_vm.pointsList, function (item, index) {
                      return _c(
                        "li",
                        { key: item.id, staticClass: "pc-item" },
                        [
                          _c("div", { staticClass: "pc-header" }, [
                            item.tagType
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "pc-tag",
                                    class: "pc-tag--" + item.tagType,
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("points_tag_" + item.tagType)
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            item.period && item.period != "none"
                              ? _c(
                                  "span",
                                  { staticClass: "pc-period theme_color" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t\t\t" +
                                        _vm._s(
                                          _vm.$t("points_period_" + item.period)
                                        ) +
                                        " " +
                                        _vm._s(item.used) +
                                        "/" +
                                        _vm._s(item.limit) +
                                        "\n\t\t\t\t\t\t\t\t"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _c("div", { staticClass: "pc-img-wrap" }, [
                            _c("img", {
                              staticClass: "pc-img",
                              attrs: { src: item.icon, alt: "" },
                            }),
                          ]),
                          _c(
                            "div",
                            { staticClass: "pc-name" },
                            _vm._l(item.rewards, function (reward, ri) {
                              return _c("p", { key: ri }, [
                                _vm._v(_vm._s(reward)),
                              ])
                            }),
                            0
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "pc-btn bg_color",
                              class: {
                                "pc-btn--disabled": _vm.isExhausted(item),
                              },
                              attrs: {
                                id: "btn_" + item.id,
                                disabled: _vm.isExhausted(item),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.exchangeRewards(item)
                                },
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "pc-btn-inner",
                                  attrs: { id: "btn_span_" + item.id },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(item.cost) +
                                      "\n\t\t\t\t\t\t\t\t\t"
                                  ),
                                  _c("img", {
                                    staticClass: "pc-coin",
                                    attrs: {
                                      src: "/static/image/points_new.png",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("p", { staticClass: "h3" }, [
                    _vm._v(_vm._s(_vm.$t("recharge_instructions_text"))),
                  ]),
                  _c("p", {
                    staticClass: "instructions",
                    domProps: { innerHTML: _vm._s(_vm.gameData.describe) },
                  }),
                ]),
              ],
              1
            ),
          ]),
          _c("Footer"),
        ],
        1
      ),
      _c("TipsWindow", { ref: "tips" }),
      _c("RewardPopup", { ref: "rewardPopup" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "naverwebtoon" }, [
      _c("img", {
        staticClass: "close b-close",
        attrs: { src: require("../assets/image/close.png"), alt: "" },
      }),
      _c("a", { attrs: { href: "" } }, [
        _c("img", {
          attrs: {
            src: require("../assets/image/naverwebtoon_bigbanner.png"),
            alt: "",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }